<template>
  <v-app class="bg-lightBlue">
    <v-container>
      <v-row class="justify-center">
        <v-col class="col-12 col-md-10">
          <div class="d-inline-flex primary--text">
            <v-icon class="mr-2" color="primary">calendar_today</v-icon>
            <h2>Agendamento</h2>
          </div>
        </v-col>
      </v-row>
      <v-row class="justify-center">
        <v-col class="col-12">
          <v-row
            class="justify-center align-center flex-column"
            v-if="isLoading"
          >
            <p>Carregando...</p>
            <v-progress-circular
              indeterminate
              color="primary"
              class="mb-0"
            ></v-progress-circular>
          </v-row>
          <v-snackbar v-model="snackbar" :color="resultSnack" :timeout="3000">
            {{ msg }}
            <v-btn dark text @click="snackbar = false">Close</v-btn>
          </v-snackbar>
          <v-row class="justify-center" v-if="!isLoading">
            <v-col class="col-12 col-md-5">
              <div>
                <v-autocomplete
                  solo
                  flat
                  hide-no-data
                  clearable
                  label="Fuso horário"
                  :items="time_zone"
                  v-model="time_zone_name"
                  @change="timeZone"
                  background-color="#F7F7F7"
                ></v-autocomplete>
              </div>
              <v-col
                class="col-12 d-flex align-center justify-end pt-0 mb-3 pr-0"
              >
                <div
                  class="pl-12"
                  style="
                    background: #f7f7f7;
                    padding: 13px 0;
                    border-radius: 12px;
                    width: calc(100% - 46px);
                    position: relative;
                  "
                >
                  <div style="position: absolute; left: -50px; top: 0">
                    <v-avatar size="90">
                      <v-img v-if="user.photo != ''" :src="user.photo">
                        <template v-slot:placeholder>
                          <v-row fill-height align-center justify-center ma-0>
                            <v-progress-circular
                              indeterminate
                              color="primary"
                            ></v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>

                      <v-img
                        v-if="user.photo == ''"
                        :src="require('../../assets/no-image.png')"
                      ></v-img>
                    </v-avatar>
                  </div>
                  <p class="mb-2 font-weight-bold subheading">
                    {{ user.name }}
                  </p>
                  <p class="ma-0">
                    <span class="font-weight-bold">Nacionalidade:</span>
                    {{ user.country }}
                  </p>
                </div>
              </v-col>
              <v-date-picker
                v-model="date"
                :events="arrayEvents"
                full-width
                locale="pt-br"
                event-color="secondary"
                color="primary"
                :min="minDate"
                :picker-date.sync="pickerDate"
              ></v-date-picker>
              <div class="date__slected px-4 py-2">
                <p>
                  Data selecionada:
                  <span>{{ date | formatDate }}</span>
                </p>
              </div>
              <div class="my-3">
                <h3 class="primary--text">Horários Disponíveis</h3>
                <v-row class="row wrap px-3">
                  <v-radio-group v-model="selected">
                    <v-radio
                      class="list__hours"
                      v-for="(hour, index) in hoursOpen"
                      :key="index"
                      :label="hour.description"
                      :value="hour.value"
                      v-bind="validationHour(hour.description)"
                    ></v-radio>
                  </v-radio-group>
                </v-row>
              </div>
            </v-col>
            <v-col class="col-12 col-md-5">
              <div class="mb-5">
                <h2 class="primary--text font-weight-bold f-12 mb-2">
                  Forma de Pagamento
                </h2>
              </div>
              <template v-if="!cartaoSelecionado">
                <CardSelectPayment
                  v-model="cartaoSelecionado"
                  class="mb-4"
                  cardType="Cartão de Crédito"
                  paymentMethodType="credit_card"
                  :itens="patientCards"
                />

                <PixPayment
                  v-if="lang === 'pt-BR'"
                  v-model="cartaoSelecionado"
                  paymentMethodType="pix"
                  :validationPix="validationPix"
                />
                <template v-if="lang === 'pt'">
                  <CardSelectPayment
                    v-model="cartaoSelecionado"
                    class="mb-4"
                    cardType="Débito Direto (SEPA)"
                    paymentMethodType="sepa_account"
                    :itens="patientSepa"
                  />
                  <MethodMultibanco
                    v-model="cartaoSelecionado"
                    paymentMethodType="multibanco"
                  />
                </template>
              </template>
              <template v-else>
                <SelectedPayment
                  :selectedTypePaymentMethod.sync="cartaoSelecionado"
                  :paymentMethodType="cartaoSelecionado.payment_method_type"
                  @clear="cartaoSelecionado = null"
                />
              </template>
              <MultibankDialogo
                ref="multibankDialogo"
                @copy="okcopy"
                @ok="okMutibacoDialog"
                :entity="entity"
                :reference="reference"
              />
              <PixDialog ref="pixDialog" @ok="okPixDialog" />
              <div class="content_pagamento mt-10">
                <div
                  v-if="cupom && cupomCode.length > 0"
                  style="
                    margin: 0 0 8px 0;
                    padding: 12px 24px;
                    heigth: 76.8px;
                    width: 100%;
                    max-width: 470px;
                    background: #f7f7f7f7;
                  "
                >
                  <p class="ma-0 gray--text mr-1">
                    Valor:<span class="ma-0 secondary--text">{{
                      value | currency
                    }}</span>
                  </p>
                  <p class="ma-0 gray--text mr-1">
                    {{ $t('schedulingPage.coupon') }} ({{
                      cupom.descriptionCoupon
                    }}%):
                    <span class="ma-0 secondary--text">
                      -{{ cupom.discountValue | currency }}</span
                    >
                  </p>
                </div>
                <div class="cupom_contet">
                  <label class="gray--text font-weight-black" for=""
                    >{{ $t('schedulingPage.discountCoupon') }}:</label
                  >
                  <input
                    v-model="cupomCode"
                    style="padding: 2px"
                    v-debounce:300="checkCupom"
                    type="text"
                    :placeholder="$t('schedulingPage.typeYourCoupon')"
                    ref="cupomInput"
                  />
                  <div @click="clearCupom" v-if="cupomCode">
                    <img
                      :src="require('../../assets/close-circle.svg')"
                      style="margin-left: 8px; cursor: pointer"
                      width="20px"
                    />
                  </div>
                </div>
                <p
                  class="
                    valor_consulta
                    gray--text
                    lightGray
                    pa-4
                    text-sm-center
                    subheading
                    font-weight-black
                  "
                >
                  Valor da consulta:
                  <span class="secondary--text ml-2">
                    {{ cupom ? cupom.valueTotal : value | currency }}
                  </span>
                </p>
                <v-btn
                  large
                  color="secondary"
                  style="align-self: center"
                  :loading="loader"
                  :disabled="isDisabled || !cartaoSelecionado"
                  @click="sendSchedule"
                >
                  AGENDAR
                </v-btn>
                <v-dialog v-model="dialog" persistent max-width="390">
                  <v-card>
                    <v-card-title class="headline"
                      >Confirmar agendamento</v-card-title
                    >
                    <v-card-text>
                      Tem certeza de que deseja realizar o agendamento?
                      <p class="font-weight-bold">
                        Ao clicar em Ok o seu agendamento será confirmado.<br />
                        No dia e horário da consulta o link para a vídeo chamada
                        será disponibilizada no detalhe da sua consulta.
                      </p>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="gray darken-1" text @click="dialog = false"
                        >Cancelar</v-btn
                      >
                      <v-btn
                        color="secondary darken-1"
                        text
                        @click="scheduleHours()"
                        >OK</v-btn
                      >
                    </v-card-actions>
                  </v-card>
                </v-dialog>
                <v-btn
                  class="mt-6"
                  text
                  style="align-self: center"
                  @click="$router.go(-1)"
                  >Cancelar</v-btn
                >
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-dialog v-model="dialogNoCards" persistent max-width="400">
        <v-card class="px-3 py-7">
          <v-card-title
            class="
              justify-center
              text-center
              font-weight-bold
              f-14
              secondary--text
              pt-1
              px-0
            "
            >Você não possui nenhuma forma de pagamento!</v-card-title
          >
          <v-card-text
            class="text-center color-darkGray px-0"
            style="line-height: 17px"
            >Você deseja criar agora a sua forma de pagamento para poder agendar
            consultas?</v-card-text
          >
          <v-card-actions class="justify-center">
            <v-btn
              width="150"
              height="40"
              outlined
              color="gray"
              class="font-weight-bold"
              @click="dialogNoCards = false"
              >Cancelar</v-btn
            >
            <v-btn
              width="150"
              to="/paciente/PaymentMethods/"
              height="40"
              class="bg-green color-white"
              >Criar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <template v-if="lang === 'pt'">
        <SchedulingDialog
          ref="schedulingDialog"
          @ok="dialogOK"
          email="geral@ondivan.net"
        />
      </template>
    </v-container>
  </v-app>
</template>

<script>
import moment from 'moment-timezone';

// eslint-disable-next-line import/extensions
import MethodMultibanco from '@/components/PaymentMethods/MethodMultibanco.vue';
import CardSelectPayment from '@/components/PaymentMethods/CardSelectPayment.vue';
import SelectedPayment from '@/components/PaymentMethods/SelectedPayment.vue';
import PixPayment from '@/components/PaymentMethods/Pix.vue';
import MultibankDialogo from '@/components/PaymentMethods/MultibankDialog.vue';

import PixDialog from '@/components/PaymentMethods/PixDialog.vue';

import { getCreditCards } from '../../services/patients';
import { getMethodSepa } from '../../services/paymentMethodSepa';
import Api from '../../services/httpClient';
import * as cardTypes from '../../store/modules/cards/types';
import sepa from '../../../Sepa.json';
import SchedulingDialog from '../../components/PaymentMethods/SchedulingDialog.vue';
import getLanguage from '../../utils/getLanguage';

export default {
  components: {
    MethodMultibanco,
    CardSelectPayment,
    SelectedPayment,
    MultibankDialogo,
    SchedulingDialog,
    PixPayment,
    PixDialog,
  },
  data() {
    return {
      // teste: null,
      sepa,
      loader: false,
      isDisabled: true,
      isLoading: false,
      dialog: false,
      dialogNoCards: false,
      user: {},
      value: '',
      codPsi: '',
      selected: '',
      date: new Date().toISOString().substr(0, 10),
      arrayEvents: [],
      hoursOpen: [],
      page: 1,
      msg: '',
      snackbar: false,
      resultSnack: '',
      time_zone: moment.tz.names(),
      time_offset: '',
      time_zone_name: '',
      patientCards: [],
      patientSepa: [],
      pickerDate: null,
      cartaoSelecionado: null,
      cupomCode: '',
      isCupom: false,
      cupom: null,
      entity: '',
      reference: '',
      lang: '',
      hourSelected: '',
      validationPix: true,
    };
  },
  async created() {
    this.lang = getLanguage(window.location.href);
    await this.getCod();
    await this.getUser();
    await this.getTimeZone();
    await this.getHours();
    await this.getPatientCards();
    await this.hendleWithStripePayment();
    await this.getPatientMethodoSepa();
  },
  computed: {
    /**
     * Informa para o datepicker a data minima para ser escolhida.
     */
    minDate() {
      const today = new Date();
      return this.formatDate(today);
    },
  },
  mounted() {
    this.isAlert();
  },
  watch: {
    /**
     * Reconhece quando uma a variavel date é modificada e chama a
     * função que pegar as horas livres daquela data.
     */
    // eslint-disable-next-line no-unused-vars
    async date(val) {
      this.isDisabled = true;
      await this.getHours();
    },

    /**
     * Verifica que ocorreu uma alteração na variavel $selected
     * e desabilita o botão Agendar.
     */
    selected(val) {
      if (val !== '') {
        this.isDisabled = false;
      }
    },

    time_zone_name(val) {
      if (val) {
        this.getHours();
      }
    },

    pickerDate(val) {
      this.monthYear(val);
    },
  },
  methods: {
    validationHour(value) {
      const today = new Date();
      var availableAppointments = this.hoursOpen;
      var selectedTime = '';
      var currentTime = today.getHours();

      availableAppointments.find((object) => {
        if (object.value === this.selected) {
          selectedTime = object.description;
        }
      });
      if (this.date === this.formatDate(today)) {
        if (parseInt(selectedTime) - parseInt(currentTime) <= 1) {
          this.validationPix = false;
        }
      } else {
        this.validationPix = true;
      }
    },
    isAlert() {
      const { schedulingDialog } = this.$refs;
      if (!schedulingDialog) return;

      schedulingDialog.openDialog();
    },
    async getPatientMethodoSepa() {
      this.isLoading = true;
      const res = await getMethodSepa();
      this.patientSepa = res.data;
      this.isLoading = false;
    },
    sendSchedule() {
      this.dialog = true;
    },
    okMutibacoDialog() {
      // this.dialog = true;
    },
    okcopy() {
      this.msg = 'Código do Multibanco foi copiado !';
      this.snackbar = true;
      navigator.clipboard.writeText(
        `Entidade: ${this.entity} Referência: ${this.reference}`,
      );
    },
    clearCupom() {
      this.cupomCode = '';
      this.cupom = null;
      this.valueTotal = this.value;
    },
    handleWithCupom() {
      const discountValue =
        parseFloat(this.cupom.coupon.value / 100) * this.value;
      const valueTotal =
        this.value - parseFloat(this.cupom.coupon.value / 100) * this.value;
      const descriptionCoupon = this.cupom.coupon.value;
      // eslint-disable-next-line no-self-assign
      this.valueTotal = this.valueTotal;
      this.cupom = {
        ...this.cupom,
        discountValue,
        valueTotal,
        descriptionCoupon,
      };
    },
    checkCupom() {
      const { id } = this.$route.params;
      try {
        Api.get(`/coupons/${this.cupomCode}/${id}`)
          .then((res) => {
            this.$refs.cupomInput.style.color = ' #02a554';
            this.cupom = res.data;
            this.handleWithCupom();
          })
          .catch((error) => {
            this.$refs.cupomInput.style.color = 'red';
          });
      } catch (error) {
        this.clearCupom();
      }
    },
    selecionarCartao(cartao) {
      this.cartaoSelecionado = cartao;
    },

    async getPatientCards() {
      this.isLoading = true;
      const res = await getCreditCards();
      this.patientCards = res;
      // if (this.patientCards.length === 0) {
      //   this.$store.commit(`cards/${cardTypes.MUTATE_FIRST_CARD}`, true);
      //   this.dialogNoCards = true;
      // }
      this.isLoading = false;
    },
    async resetAppointment(appointmentId) {
      await Api.post('reset_appointment/', { appointmentId });
      this.listHours();
    },
    async hendleWithStripePayment() {
      if (window.location.search.search('payment_intent') === -1) return;
      this.isLoading = true;
      Api.get(`check_payment/${window.location.search}`)
        .then(({ data }) => {
          if (data && data.last_payment_error) {
            this.msg = 'Pagamento não autorizado!';
            this.snackbar = true;
            this.resetAppointment(data.id);
          } else {
            this.$router.replace('/paciente/schedule');
          }
        })
        .catch((err) => {})
        .finally(() => {
          this.isLoading = false;
        });
    },
    async monthYear(value) {
      const res = value.split('-');
      const year = res[0];
      const month = res[1];
      if (year != undefined && month != undefined)
        await this.allScheduleOpneMonth(month, year);
    },
    /**
     * Pega o time zone escolhido pelo paciente
     */
    timeZone(val) {
      const m = moment().tz(val);
      this.time_offset = m.format('Z');
      this.time_zone_name = val;
    },
    /**
     * formata data e retorna para a função que vai informa ao datepicker
     * apartir de que data inicia.
     * params: $date
     */
    formatDate(date) {
      let month = `${date.getMonth() + 1}`;
      let day = `${date.getDate()}`;
      const year = date.getFullYear();

      if (month.length < 2) month = `0${month}`;
      if (day.length < 2) day = `0${day}`;

      return [year, month, day].join('-');
    },
    /**
     * Pega o id(codigo) do usuario que é passado vai parametro na rota.
     */
    getCod() {
      this.codPsi = this.$route.params.id;
    },
    /**
     * Pega os dados do psicologo
     */
    async getUser() {
      this.isLoading = true;
      Api.get(`/psychologists/${this.codPsi}/`)
        .then((response) => {
          this.user = response.data;
          if (this.user.appointment_br_value === '0.00') {
            this.value = parseFloat(this.user.appointment_pt_value);
          } else {
            this.value = parseFloat(this.user.appointment_br_value);
          }
        })
        .catch((err) => {})
        .finally(() => {
          this.isLoading = false;
        });
    },
    /**
     * Pega todos os dias e horarios vagos aparti do mês e ano selecionado
     * e coloca em na variavel arrayEvents para ser sinalizado
     * no datapicker os dias que tem horarios vagos.
     */
    async allScheduleOpneMonth(month, year) {
      try {
        const { data, status } = await Api.get(
          `/psychologists/${this.codPsi}/time_slots/?year=${year}&month=${month}`,
        );
        if (status === 200) {
          // eslint-disable-next-line no-restricted-syntax
          for (const item of data) {
            this.arrayEvents.push(item.date);
          }
        }
      } catch (error) {}
    },

    async getHours() {
      Api.get(`/psychologists/${this.codPsi}/time_slots/`, {
        params: {
          date: this.date,
        },
      })
        .then((response) => {
          this.listHours(response.data);
          this.selected = '';
        })
        .catch((error) => {});
    },
    /**
     * Através da array de horarios passado a função gera uma nova array
     * de objeos com value e description
     * { value 15:00, description 15h-16h}.
     */
    async listHours(val) {
      this.hoursOpen = [];

      const listFilter = await val.filter((item) => {
        const utcNow = `${moment.utc().format('YYYY-MM-DD HH:mm:ss')}`;
        const dateTime = `${item.date} ${item.time}`;
        return dateTime > utcNow;
      });

      // eslint-disable-next-line no-restricted-syntax
      for (const item of listFilter) {
        item.time = moment
          .utc(`${item.date} ${item.time}`)
          .tz(`${this.time_zone_name}`)
          .format('HH:mm:ss');
        const splitTime = item.time.split(':');
        let axuDesc = parseInt(splitTime[0], 10) + 1;
        // eslint-disable-next-line prefer-template
        axuDesc = ('0' + axuDesc).substr(-2);
        // eslint-disable-next-line prefer-template
        const auxDescription = `${item.time.replace(
          ':00:00',
          'h',
        )}-${axuDesc}h`;
        const auxHours = {
          value: item.id,
          description: auxDescription,
        };
        this.hoursOpen.push(auxHours);
      }
    },
    /**
     * Agenda uma seção com o psicologo, passando o id da data/horario na URL
     * e como parametro o id do paciente.
     */
    scheduleHours() {
      this.dialog = false;
      this.loader = true;
      const isSelectedCard =
        this.cartaoSelecionado.payment_method_type === 'credit_card';
      const coupomValue = this.cupom ? this.cupom.coupon.value : null;
      const discountValue = this.cupom ? this.cupom.discountValue : null;
      const couponId = this.cupom ? this.cupom.id : null;
      Api.post(
        `/psychologists/${this.codPsi}/time_slots/${this.selected}/scheduling/`,
        {
          patient: localStorage.getItem('user-id'),
          typePaymentMethod: this.cartaoSelecionado.payment_method_type,
          sepaAccountId: !isSelectedCard ? this.cartaoSelecionado.id : null,
          creditCardId: isSelectedCard ? this.cartaoSelecionado.id : null,
          return_url: window.location.href,
          coupon_value: coupomValue,
          discount_coupon_value: discountValue,
          coupon_id: couponId,
        },
      )
        .then((response) => {
          const idConsult = response.data.id;
          if (this.cartaoSelecionado.payment_method_type === 'multibanco') {
            this.entity = response.data.payment_intent.multibanco.entity;
            this.reference = response.data.payment_intent.multibanco.reference;
            const { multibankDialogo } = this.$refs;
            if (multibankDialogo) {
              multibankDialogo.openDialog();
            }
          } else if (this.cartaoSelecionado.payment_method_type === 'pix') {
            const { pixDialog } = this.$refs;
            if (pixDialog) {
              pixDialog.openDialog();
            }
          }
          if (
            response.data.payment_intent.next_action &&
            response.data.payment_intent.next_action.redirect_to_url.url
          ) {
            window.location.href =
              response.data.payment_intent.next_action.redirect_to_url.url;
            return;
          }
          this.isDisabled = true;
          this.msg = 'Agendamento realizado com sucesso!';
          // this.resultSnack = "success";
          this.snackbar = true;

          setTimeout(() => {
            this.$router.replace(`/paciente/detalhe-consulta/${idConsult}`);
          }, 10000);
        })
        .catch((err) => {
          this.$showSnackbar(
            'Erro ao realizar o agendamento. Tente Novamente.',
          );
        })
        .finally(() => {
          this.loader = false;
        });
    },
    getTimeZone() {
      const dataUser = localStorage.getItem('user-data');
      this.time_zone_name = JSON.parse(dataUser).time_zone_name;
    },
  },
};
</script>

<style scoped>
* >>> .list__hours {
  margin-top: 0px;
}

* >>> .list__hours .v-input--selection-controls__input {
  display: none;
}

* >>> .v-input--radio-group__input {
  display: flex;
  flex-direction: row !important;
  justify-content: center;
  align-items: flex-start;
  flex-wrap: wrap;
}

* >>> .list__hours {
  margin-bottom: 0;
  background: #cbcbcb;
  padding: 8px 16px;
  border-radius: 23px;
}

* >>> .list__hours.v-item--active {
  background: #02a554;
}

* >>> .list__hours.v-item--active .v-label {
  color: #fff;
}

* >>> .list__hours .v-label {
  color: #000000;
}

.date__slected {
  background-color: #e3ffe3;
}
.date__slected p {
  color: #6f6f6f;
  margin: 0;
  position: relative;
}
.date__slected p span {
  color: #02a554;
  font-size: 16px;
  font-weight: bold;
  position: absolute;
  right: 5px;
}
.content_pagamento {
  display: flex;
  width: 100%;
  max-width: 470px;
  flex: 1;
  justify-content: center;
  align-items: center;
  text-align: center;
  flex-direction: column;
}
.cupom_contet {
  padding: 12px 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  background: #f7f7f7f7;
  margin-bottom: 4px;
  height: 76.8px;
  width: 100%;
  max-width: 470px;
  margin: 0 0 8px 0;
}

.cupom_contet input {
  width: 140px;
  margin-left: 8px;
  padding: 8px 0;
  border-style: initial;
  appearance: none;
  outline: none;
  border-bottom: 1px solid #02a554;
  color: #02a554;
}
.cupom_contet input::placeholder {
  color: #02a554;
}
.valor_consulta {
  margin: 0 0 8px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 12px 24px;
  height: 76.8px;
  width: 100%;
  max-width: 470px;
  background: #f7f7f7;
}
@media screen and (max-width: 420px) {
  .valor-cartao {
    font-size: 0.9rem !important;
  }
  .cupom_contet {
    flex-direction: column;
    margin-bottom: 8px;
  }
}

/* *>>> .v-date-picker-table .v-btn.v-btn--active,
*>>> .v-date-picker-table .v-btn.v-btn--outlined {
  border-radius: 28px;
} */
</style>
